// Custom "< Back" Button in Product Page

document.addEventListener('DOMContentLoaded', function () {
  // 1. Navigation Tracking Logic
  // This runs on every product page to ensure the history depth is accurate,
  // even if the "back" button is hidden on intermediate pages.
  var ref = document.referrer;
  var keyDepth = 'collection_nav_depth';
  var keyUrl = 'collection_nav_url';
  var currentDepth = parseInt(sessionStorage.getItem(keyDepth) || '0');
  var storedUrl = sessionStorage.getItem(keyUrl);

  if (ref.indexOf('/collections/') !== -1 && ref.indexOf('/products/') === -1) {
    sessionStorage.setItem(keyDepth, 1);
    sessionStorage.setItem(keyUrl, ref);
    currentDepth = 1;
    storedUrl = ref;
  }

  else if (ref === '' || (ref && ref.indexOf(window.location.host) === -1)) {
    sessionStorage.removeItem(keyDepth);
    sessionStorage.removeItem(keyUrl);
    currentDepth = 0;
    storedUrl = null;
  }

  // 2. Button Behavior Logic
  // Only applies if the button exists and we have a valid collection to return to.
  var backBtn = document.getElementById('BackToCollection');
  if (backBtn && storedUrl) {
    backBtn.href = storedUrl;
    backBtn.addEventListener('click', function (e) {
      if (currentDepth > 0) {
        e.preventDefault();
        history.go(-currentDepth);
      }
    });
  }

  // 3. Clear navigation state when leaving PDP via any link other than "< Back".
  // This prevents stale history.go() depth when revisiting a PDP from a different path.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link || link === backBtn) return;
    sessionStorage.removeItem(keyDepth);
    sessionStorage.removeItem(keyUrl);
    sessionStorage.removeItem('infinite_scroll_state');
    sessionStorage.removeItem('infinite_scroll_y');
  });
});
